import React from 'react';
import styled from 'styled-components';
import { primaryText } from 'styles/colors';

const StyledText = styled.p`
  font-family: 'Crossten';
  font-weight: ${({ fontWeight }) => fontWeight || 300};
  font-size: ${({ fontSize }) => fontSize || '16px'};
  margin: ${({ margin }) => margin || 0};
  color: ${({ color }) => color || primaryText};
  text-decoration: none;
  display: ${({ display }) => display || 'block'};
  cursor: ${({ cursor }) => cursor || 'default'};
`;

const Text = ({ children, ...props }) => {
  return <StyledText {...props}>{children}</StyledText>;
};

export default Text;
